const { REACT_APP_S3_CLIP_BUCKET } = process.env;

// Hardcoded mock data for Top 5 creators (temporary)
export const MOCK_TOP_5_PLAYERS = [
  {
    internalId: "mock-maxster",
    username: "maxster",
    avatar: `${REACT_APP_S3_CLIP_BUCKET}/static/web/top5/users/maxster.webp`,
    externalProfileUrl: "https://www.hltv.org/player/20879/maxster",
  },
  {
    internalId: "mock-boye",
    username: "Boye",
    avatar: `${REACT_APP_S3_CLIP_BUCKET}/static/web/top5/users/boye.webp`,
    externalProfileUrl: "https://www.hltv.org/player/21574/boye",
  },
  {
    internalId: "mock-junior",
    username: "junior",
    avatar: `${REACT_APP_S3_CLIP_BUCKET}/static/web/top5/users/junior.webp`,
    externalProfileUrl: "https://www.hltv.org/player/14494/junior",
  },
  {
    internalId: "mock-rainwaker",
    username: "Rainwaker",
    avatar: `${REACT_APP_S3_CLIP_BUCKET}/static/web/top5/users/rainwaker.webp`,
    externalProfileUrl: "https://www.hltv.org/player/17145/rainwaker",
  },
  {
    internalId: "68dad43cd3eef549dba09888",
    username: "2Nkaus",
    avatar:
      "https://avatars.steamstatic.com/51d16180aecdb693ad845adb6147f3c2e5805a92_full.jpg",
  },
];
